import { AlertDTO } from "@/api/types/main/schemas";
import { create } from "zustand";

interface AlertStore {
  alerts: AlertDTO[];
  isConnected: boolean;
  error: string | null;
  setIsConnected: (isConnected: boolean) => void;
  setError: (error: string | null) => void;
  addAlert: (alert: AlertDTO) => void;
  clearAlerts: () => void;
}

export const useAlertStore = create<AlertStore>()((set) => ({
  alerts: [],
  isConnected: false,
  error: null,
  setIsConnected: (isConnected: boolean) => set({ isConnected }),
  setError: (error: string | null) => set({ error }),
  addAlert: (alert: AlertDTO) =>
    set((state) => ({
      alerts: [...state.alerts, alert],
    })),
  clearAlerts: () => set({ alerts: [] }),
}));
